angular.module("ainapp")
    .controller("productSeriesController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Product Series";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Init = function () {

                $scope.filter = {
                    ProductIds: [],
                }
                $scope.load = false;

            }
            $scope.Init();

            $scope.productSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length > 0) {
                                MainService.productInAutoComplete(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("Network Error");
                                });
                            } else {
                                o.success({
                                    Data: []
                                });
                            }
                        } else {
                            o.success({
                                Data: []
                            });
                        }

                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.selectProductOptions = {
                placeholder: "Select Products...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.productSelectDataSource
            };


            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {

                        o.data.ProductIds = $scope.filter.ProductIds;

                        MainService.ProductSerialNoView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })


                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            "Product.Name": {
                                type: "string",
                                editable: false,
                            },
                            SerialNo: {
                                type: "string",
                                editable: false,
                            },
                            PurchaseInvNo: {
                                type: "string",
                                editable: false,
                            },
                            PurchaseInvType: {
                                type: "string",
                                editable: false,
                            },
                            PurchaseDate: {
                                type: "date",
                                editable: false,
                            },
                            SalesInvNo: {
                                type: "string",
                                editable: false,
                            },
                            SalesInvType: {
                                type: "string",
                                editable: false,
                            },
                            SalesDate: {
                                type: "date",
                                editable: false,
                            },
                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
                group: [{
                    field: "Product.Name",
                    }],
            });

            $scope.KendoGridOptions = {
                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 700,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [
                    {
                        field: "Product.Name",
                        title: "Product",
                        width: "220px",
                        hidden: true,
                        },
                    {
                        field: "SerialNo",
                        title: "Serial No",
                        width: "100px",
                     },
                    {
                        field: "PurchaseInvNo",
                        title: "Purchase No",
                        width: "100px",
                     },

                    {
                        field: "PurchaseInvType",
                        title: "Purchase Type",
                        width: "100px",
                     },
                    {
                        field: "PurchaseDate",
                        title: "Purchase Date",
                        width: "100px",
                        template: "<p >{{dataItem.PurchaseDate |date: 'dd/MM/yyyy'}}</p>"
                     },


                    {
                        field: "SalesInvNo",
                        title: "Sales No",
                        width: "100px",
                     },
                    {
                        field: "SalesInvType",
                        title: "Sales Type",
                        width: "100px",
                     },
                    {
                        field: "SalesDate",
                        title: "Sales Date",
                        width: "100px",
                        template: "<p >{{dataItem.SalesDate |date: 'dd/MM/yyyy'}}</p>"
                     },

                    ],
            };


            $scope.Filter = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.QueueDetails = [];
            $scope.View = function (data) {

                $scope.QueueDetails = [];
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.GetPurchaseQueueDetails(data.Id).then(function (response) {
                    if (response.data) {
                        $scope.QueueDetails = response.data;
                        $('#viewDetailModal').modal('show');
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                })

            }




        }])
